import * as actionTypes from '../actionTypes/campaign';

export function getCampaignData({ pageContext, categoryData, productData, cartHasLoyaltyBenefits, loyaltyCount, brand, classification, usePristineData }) {
    return {
        type: actionTypes.GET_CAMPAIGN_DATA,
        pageContext,
        categoryData,
        productData,
        cartHasLoyaltyBenefits,
        loyaltyCount,
        brand,
        classification,
        usePristineData
    };
}

export function setParams(query) {
    return {
        type: actionTypes.SET_QUERY_PARAMS,
        query
    };
}
